<div>
  <h2>{{'historico-reetiquetado.titulo' | translate}}</h2>
  <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
  <section class="filters-framed" *ngIf="filtersVisible">
    <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.pais' | translate}} *</label>
        <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'historico-reetiquetado.filters.denominacion' | translate}} *</label>
        <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
          [disabled]="disabledDenominaciones" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'historico-reetiquetado.filters.campanya' | translate}} *</label>
        <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
          [disabled]="disabledCampanyas" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'historico-reetiquetado.filters.etiquetador' | translate}}</label>
        <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
          [disabled]="disabledEtiquetadores" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.almacen' | translate}}</label>
        <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
          [disabled]="disabledAlmacenes" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'historico-reetiquetado.filters.marca' | translate}}</label>
        <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')" [disabled]="disabledMarcas"
          [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'historico-reetiquetado.filters.destino' | translate}}</label>
        <app-filterable-list [itemsList]="destinos" [selectedItem]="filtersForm.get('paisDestino')"
          [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.inicio' | translate}}</label>
        <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}"
          formControlName="fechaInicio" (click)="fechaInicio.open()">
        <mat-datepicker #fechaInicio></mat-datepicker>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.fin' | translate}}</label>
        <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}"
          formControlName="fechaFin" (click)="fechaFin.open()">
        <mat-datepicker #fechaFin></mat-datepicker>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
    </form>
  </section>
  <section class="filters-buttons">
    <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
      title="{{'global.filtros.abrir' | translate}}">
      <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
      (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
      <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary"
      [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
      title="{{'global.filtros.limpiar' | translate}}">
      <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
    </button>
    <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
      title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
      <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
    </button>
  </section>
  <section class="export-buttons">
    <i class="fas fa-file-pdf" [ngClass]="{'disabled': !historicoReetiquetado}"
      (click)="exportModal = 1" title="{{'titles.exportarPDF' | translate}}"></i>
    <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
  </section>
  <section *ngIf="!historicoReetiquetado || historicoReetiquetado.length === 0">
    <div class="no-data">{{'global.noContent' | translate}}</div>
  </section>
  <section class="tabs" *ngFor="let historico of historicoReetiquetado; index as i;">
    <content class="table-list" *ngIf="i < lastItemList && i >= firstItemList">
      <div class="title">
        <label>{{historico.desEtiquetador}}</label>
        <div><label>{{'historico-reetiquetado.table.etiquetas' | translate}}: </label>
          {{historico.sumaNumEtiquetasReimpresas | number : '' : defaultLanguage}}
          ({{historico.sumaKgReimpresos | number : '.2' : defaultLanguage}}Kg / {{historico.sumaKgImpresosEfectivos |
          number : '.2' : defaultLanguage}}Kg)</div>
      </div>
      <div class="list" *ngFor="let almacen of historico.lsEtiquetadoAlmacenDto; index as j;">
        <div class="list-title">
          <div>
            <label>{{'global.almacen' | translate}}: </label>
            {{almacen.desAlmacen}}
          </div>
          <div>
            <label>{{'historico-reetiquetado.table.etiquetas' | translate}}: </label>
            {{almacen.sumaNumEtiquetasReimpresas | number : '' : defaultLanguage}}
            ({{almacen.sumaKgReimpresos | number : '.2' : defaultLanguage}}Kg /
            {{almacen.sumaKgImpresosEfectivos | number : '.2' : defaultLanguage}}Kg)
          </div>
        </div>
        <div class="table-wrapper-smaller">
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th class="icon"></th>
                  <!-- <th class="string sortable" (click)="toOrderBy('2'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="desDenominacion">
                                  {{'historico-reetiquetado.table.denominacion' | translate}}
                                  <div class="sortable-icons">
                                    <i [ngClass]="getIcon('2'+i+j)"></i>
                                  </div>
                                </th> -->
                  <th class="string sortable" (click)="toOrderBy('3'+i+j, 3, 'desFinca', 'x=> x.desFinca')">
                    {{'global.finca' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon(3)"></i>
                    </div>
                  </th>
                  <!-- <th class="string sortable" (click)="toOrderBy('4'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="desMarca">
                                  {{'historico-reetiquetado.table.marca' | translate}}
                                  <div class="sortable-icons">
                                    <i [ngClass]="getIcon('4'+i+j)"></i>
                                  </div>
                                </th> -->
                  <th class="string sortable" (click)="toOrderBy('5'+i+j, 5, 'productores', 'x=> x.productores')">
                    {{'historico-reetiquetado.table.productor' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon(5)"></i>
                    </div>
                  </th>
                  <!-- <th class="string sortable" (click)="toOrderBy('6'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="desProvincia">
                                  {{'global.provincia' | translate}}
                                  <div class="sortable-icons">
                                    <i [ngClass]="getIcon('6'+i+j)"></i>
                                  </div>
                                </th> -->
                  <th class="string sortable" (click)="toOrderBy('7'+i+j, 7, 'desMunicipio', 'x=> x.desMunicipio')">
                    {{'global.municipio' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon(7)"></i>
                    </div>
                  </th>
                  <!-- <th class="string sortable" (click)="toOrderBy('8'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="nLicencias">
                                  {{'historico-reetiquetado.table.licencia' | translate}}
                                  <div class="sortable-icons">
                                    <i [ngClass]="getIcon('8'+i+j)"></i>
                                  </div>
                                </th> -->
                  <!-- <th class="string">{{'historico-reetiquetado.table.poligono' | translate}}</th>
                                <th class="string">{{'historico-reetiquetado.table.parcela' | translate}}</th> -->
                  <th class="number sortable" (click)="toOrderBy('9'+i+j, 9, 'sumaNumEtiquetasReimpresas', 'x=> x.sumaNumEtiquetasReimpresas')">
                    {{'historico-reetiquetado.table.etiquetas' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon(9)"></i>
                    </div>
                  </th>
                  <th class="number sortable" (click)="toOrderBy('10'+i+j, 10, 'sumaKgReimpresos', 'x=> x.sumaKgReimpresos')">
                    {{'historico-reetiquetado.table.reimpresos' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon(10)"></i>
                    </div>
                  </th>
                  <th class="number sortable" (click)="toOrderBy('11'+i+j, 11, 'sumaKgImpresosEfectivos', 'x=> x.sumaKgImpresosEfectivos')">
                    {{'historico-reetiquetado.table.consumidos' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon(11)"></i>
                    </div>
                  </th>
                  <th class="progress">{{'historico-reetiquetado.table.reetiquetado' | translate}}</th>
                  <th class="action"></th>
                </tr>
              </thead>
              <tbody *ngFor="let cultivo of almacen.lsEtiquetadoCultivoDto; index as k;">
                <tr (click)="showDetails('index'+i+j+k);" [ngClass]="{'dropdownInfo': dropdownInfo === 'index'+i+j+k}">
                  <td class="icon"><i
                      [ngClass]="dropdownInfo === 'index'+i+j+k ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                      title="{{dropdownInfo === 'index'+i+j+k ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                  </td>
                  <!-- <td class="string">{{cultivo.desDenominacion}}</td> -->
                  <td class="string">{{cultivo.desFinca}}</td>
                  <!-- <td class="string">{{cultivo.desMarca}}</td> -->
                  <td class="string">{{cultivo.productores}}</td>
                  <!-- <td class="string">{{cultivo.desProvincia}}</td> -->
                  <td class="string" title="{{cultivo.desMunicipio}} ({{cultivo.desProvincia}})">{{cultivo.desMunicipio}}
                  </td>
                  <!-- <td class="string">{{cultivo.nLicencias}}</td> -->
                  <!-- <td class="string">{{cultivo.poligonoCatastral}}</td>
                                <td class="string">{{cultivo.parcelaCatastral}}</td> -->
                  <td class="number">{{cultivo.sumaNumEtiquetasReimpresas | number : '1.0-0': defaultLanguage}}</td>
                  <td class="number">{{cultivo.sumaKgReimpresos | number : '1.2-2': defaultLanguage}}</td>
                  <td class="number">{{cultivo.sumaKgImpresosEfectivos | number : '1.2-2': defaultLanguage}}</td>
                  <td class="progress"><progress
                      [ngClass]="{'exceeded': getPercent(cultivo.sumaKgReimpresos, cultivo.sumaKgImpresosEfectivos)>100}"
                      value="{{getPercent(cultivo.sumaKgReimpresos, cultivo.sumaKgImpresosEfectivos)}}"
                      max="100"></progress><span>{{getPercent(cultivo.sumaKgReimpresos,
                      cultivo.sumaKgImpresosEfectivos)}}%</span>
                  </td>
                  <td class="actions">
                    <i class="fas fa-stream" app-click-stop-propagation (click)="showSection('index'+i+j+k)"
                      title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                  </td>
                </tr>
                <tr *ngIf="dropdownInfo === 'index'+i+j+k">
                  <td colspan="13">
                    <div class="detail">
                      <div class="title">{{'global.masInformacion' | translate}}</div>
                      <div class="block-inline">
                        <label>{{'historico-reetiquetado.table.denominacion' | translate}}</label>
                        <p>{{cultivo.desDenominacion}}</p>
                      </div>
                      <div class="block-inline">
                        <label>{{'historico-reetiquetado.table.marca' | translate}}</label>
                        <p>{{cultivo.desMarca}}</p>
                      </div>
                      <div class="block-inline">
                        <label>{{'historico-reetiquetado.table.licencia' | translate}}</label>
                        <p>{{cultivo.nLicencias}}</p>
                      </div>
                      <div class="block-inline">
                        <label>{{'global.provincia' | translate}}</label>
                        <p>{{cultivo.desProvincia}}</p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="dropdownSection === 'index'+i+j+k">
                  <td colspan="7">
                    <section class="tabs">
                      <ul>
                        <li>{{'historico-reetiquetado.table.tabs.confeccion.titulo' | translate}}</li>
                      </ul>
                      <content>
                        <app-desglose-confeccion-hist-reetiquetado
                          [confecciones]="cultivo.lsEtiquetadoConfeccionDto"></app-desglose-confeccion-hist-reetiquetado>
                      </content>
                    </section>
                  </td>
                </tr>
              </tbody>
              <tfoot *ngIf="!historicoReetiquetado || (historicoReetiquetado && historicoReetiquetado.length < 1)">
                <tr>
                  <td colspan="12">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </content>
  </section>
  <app-paginator *ngIf="(historicoReetiquetado && historicoReetiquetado.length > 0)" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage" [totalItems]="totalItems" [visiblePages]="visiblePages"
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
  </app-paginator>
  <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
    (closed)="showError=$event;showWarning=$event">
  </app-toast>
</div>
<div class="modal" *ngIf="exportModal > 0">
  <div class="modal-content">
      <header>
          <h4>{{'global.modalInformes.titulo' | translate}} {{exportModal === 1 ? 'PDF' : 'Excel'}}
          </h4>
          <i class="fas fa-times" (click)="exportModal = 0"></i>
      </header>
      <content>
          <button (click)="export(1)">{{'global.modalInformes.general' | translate}}</button>
          <button (click)="export(2)">{{'global.modalInformes.detallado' | translate}}</button>
      </content>
  </div>
</div>